<!-- eslint-disable -->
<template>
  <CommonPages id="about" classs="about-page" titlePrefix="About Us - Pixeloogic"
    metaDescription="Connect with premium traffic, AI-powered optimization, and dedicated support. Our global advertising platform helps advertisers and publishers achieve transparent, scalable, and performance-driven results.">

    <div class="story-section about">
      <div class="story-section__content">
        <h2 class="story-section__title">Our Story</h2>
        <h3 class="story-section__heading">We believe advertising should be transparent, efficient, and performance-focused.</h3>

      </div>
      <div class="story-swich-content">
        <div class="story-section__left">
          <img src="@/assets/story-1.png" alt="Our Story Image 1"
            class="story-section__image--main">
        </div>
        <div class="story-section__right">
          <div class="story-section__right-images">
            <img src="@/assets/story-2.png" alt="Our Story Image 2"
              class="story-section__image--top">
            <img src="@/assets/story-3.png" alt="Our Story Image 3"
              class="story-section__image--bottom">
          </div>
          <div class="story-section__content">
            <p class="story-section__text">
              Started by a team of ad tech specialists, we’ve evolved from a small platform into a global partner for advertisers and publishers. What makes us different is our data-driven technology, real industry experience, and long-term partnership mindset. Whether you're seeking premium traffic or high-quality offers, we help you grow with clarity and confidence.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="stats-section">
      <div class="stat">
        <p class="stat__number">60+</p>
        <p class="stat__description">Markets Connected — Powering campaigns across North America, Europe, and Asia.</p>
      </div>
      <div class="stat">
        <p class="stat__number">96%</p>
        <p class="stat__description">Client Retention — Built on trust, performance, and sustainable growth.</p>
      </div>
      <div class="stat">
        <p class="stat__number">1,200+</p>
        <p class="stat__description">Active Partners — Trusted by brands, agencies, and media buyers worldwide.</p>
      </div>
    </div>

    <div class="team-section">
      <div class="team-member-card">
        <img src="@/assets/team-member-1.png" alt="Alex Carter" class="team-member-card__avatar">
        <p class="team-member-card__quote">"Combining insight and innovation, Sarah transforms data into powerful decisions that elevate performance and maximize ROI."</p>
        <h4 class="team-member-card__name">Sarah Lee</h4>
        <p class="team-member-card__title">Performance Analyst</p>
      </div>
      <div class="team-member-card">
        <img src="@/assets/team-member-2.png" alt="Mia Johnson" class="team-member-card__avatar">
        <p class="team-member-card__quote">"Dedicated to creating campaigns that truly resonate, Ethan blends creativity and strategy to help brands connect and convert."</p>
        <h4 class="team-member-card__name">Ethan Brooks</h4>
        <p class="team-member-card__title">Creative Strategist</p>
      </div>
    </div>

  </CommonPages>
</template>

<script>
import CommonPages from '@/pages/components/page_common.vue';
import '@/css/about.scss';

export default {
  name: 'About',
  components: {
    CommonPages,
  },
};
</script>
